<!-- accounting-searcher.vue -->
<template>
	<div class="accounting-searcher">
		<v-layout wrap>
			<v-flex xs12>
				<v-layout wrap align-end>
					<v-flex xs7 pr-3>
						<input-searcher
							:height="32"
							:value="accountName"
							@input="handleInputName"
							@open-searcher="$emit('open-searcher')"
						/>
					</v-flex>
					<v-flex xs5>
						<BaseInput
							:height="32"
							v-model="localAccount"
							label="Cuenta Contable"
							hide-details
							@input="handleAccountInput"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import inputSearcher from '@/components/shared/searcher/input-searcher';

	export default {
		name: 'accounting-searcher',
		components: {
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			inputSearcher,
		},
		props: {
			account: [Number, String],
			accountName: String,
			placeHolder: String,
		},
		data() {
			return {
				localAccount: this.account,
			};
		},
		watch: {
			account(newVal) {
				this.localAccount = newVal;
			},
		},
		methods: {
			handleInputName(value) {
				// Emitir el nombre de la cuenta al padre
				this.$emit('update:accountName', value);
				this.$emit('input-name', value);
			},
			handleAccountInput(value) {
				// Emitir la cuenta contable al padre
				this.$emit('update:account', value);
				this.$emit('input', value);
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/shared/searcher/accounting-searcher.vue